import { createRoot } from 'react-dom/client'
import './tailwind.css'
import App from './App'

const root = document.getElementById('root')
if (!root) throw new Error('#root 가 없다 — index.html 확인')

createRoot(root).render(<App />)